module.exports = __webpack_public_path__ + "static/media/productos_apple.ecda1ac3.png";